var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-currency-field", {
        staticClass: "soli-round",
        attrs: {
          label: _vm.label,
          value: _vm.value,
          rules: _vm.optional ? [] : _vm.payRules,
          outlined: "",
          dense: "",
          "error-message": "errors.amount",
          "prepend-inner-icon": "payments",
          "hide-details": _vm.hideDetails,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }